export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    // 赛事列表
    tourList: function tourList(data) {
      return request({
        url: '/tour/tourList',
        method: 'get',
        data: data
      });
    },
    addTour: function addTour(data) {
      return request({
        url: '/tour/addTour',
        method: 'post',
        data: data
      });
    },
    updateTour: function updateTour(data) {
      return request({
        url: '/tour/updateTour',
        method: 'post',
        data: data
      });
    },
    cancelTour: function cancelTour(data) {
      return request({
        url: '/tour/cancelTour',
        method: 'post',
        data: data
      });
    },
    tourExtra: function tourExtra(data) {
      return request({
        url: '/tour/tourExtra',
        method: 'get',
        data: data
      });
    },
    updateTourExtra: function updateTourExtra(data) {
      return request({
        url: '/tour/updateTourExtra',
        method: 'post',
        data: data
      });
    },
    //关闭报名
    closeAndGenerate: function closeAndGenerate(data) {
      return request({
        url: '/tour/closeAndGenerate',
        method: 'post',
        data: data
      });
    },
    //赛事已报名球队
    regTeamList: function regTeamList(data) {
      return request({
        url: '/tour/regTeamList',
        method: 'get',
        data: data
      });
    },
    //赛事审核球队
    auditTeam: function auditTeam(data) {
      return request({
        url: '/tour/auditTeam',
        method: 'post',
        data: data
      });
    },
    //赛事审核球队
    schedule: function schedule(data) {
      return request({
        url: '/tour/schedule',
        method: 'post',
        data: data
      });
    },
    getUnassignedTeamsInRound: function getUnassignedTeamsInRound(data) {
      return request({
        url: '/match/getUnassignedTeamsInRound',
        method: 'post',
        data: data
      });
    },
    updateMatches: function updateMatches(data) {
      return request({
        url: '/match/updateMatches',
        method: 'post',
        data: data
      });
    },
    //录入比分结果
    submitResult: function submitResult(data) {
      return request({
        url: '/tour/submitResult',
        method: 'post',
        data: data
      });
    },
    //比赛轮次列表
    rounds: function rounds(data) {
      return request({
        url: '/tournaments/rounds',
        method: 'get',
        data: data
      });
    }
  };
});